import React from "react";

export interface CheckboxProps {
  name: string;
  id?: string;
  values: any;
  label: string;
  description?: string;
  className?: string;
  checked?: any;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CheckBox: React.FC<CheckboxProps> = ({
  name,
  label,
  description,
  onChange,
  className,
  values,
  id,
  disabled = false,
}) => {
  return (
    <div
      className={
        className ? className : `flex gap-4 items-start w-fit ${className}`
      }
    >
      <div className='flex items-center h-5'>
        <input
          id={id}
          name={name}
          type='checkbox'
          onChange={onChange}
          checked={values[name]}
          disabled={disabled}
          className={
            className
              ? className
              : `focus:ring-gray-500 h-4 w-4 text-gray-600 border-gray-200 flex gap-2 rounded-xl accent-[#0075d4] cursor-pointer ${
                  disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
                } ${className}`
          }
        />
      </div>
      <div className='text-sm'>
        <label
          htmlFor={id}
          className={`block text-[12px] font-bold ${
            disabled ? 'text-gray-400' : 'text-[#8E8E8E]'
          }`}
        >
          {label}
        </label>
        {description && (
          <p className={disabled ? 'text-gray-400' : 'text-[#8E8E8E]'}>
            {description}
          </p>
        )}
      </div>
    </div>
  );
};